/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2022, Zumper
 */

import * as Api from '@zcode/nr/es/shared/api'
import type { GetState } from '@zcode/state-type'
import type { History } from 'history'
import type { Dispatch } from 'redux'
import { addErrorButterBar, addSuccessButterBar } from '../../../../actions/butter.action'
import { logger } from '../../../../logger'
import { CONFIRM_EMAIL_CHANGE_ERROR, CONFIRM_EMAIL_CHANGE_SUCCESS } from './constants'

export interface ConfirmEmailChangeProps {
  token?: string | null
}

export const confirmEmailChange =
  ({ token }: ConfirmEmailChangeProps) =>
  async (dispatch: Dispatch, getState: GetState, { history }: { history: History }) => {
    if (!token) {
      logger.error('nzr confirmEmailChange attempted with no token')
      return
    }

    try {
      await Api.confirmEmailChange.query({ token })
      dispatch(addSuccessButterBar(CONFIRM_EMAIL_CHANGE_SUCCESS))
    } catch (e) {
      dispatch(addErrorButterBar(CONFIRM_EMAIL_CHANGE_ERROR))
    }

    history.push('/')
  }
